import './App.css';
import HeroSection from './screens/FirstScreen';
import IntroSection from './screens/Intersection';
import ProjectsGallery from './screens/ProjectsGallery';
import Navigation from './components/Nav/Nav';
import ShirleyProjects from './screens/AllProjects';
import ServicesScreen from './components/Services/Services';
import AboutShirley from './components/me/Me';
import AboutMe from './components/me/Me';
import FAQ_ShirleyGoldstein from './components/questions/Questions';
import ShirliQuate from './quate/Quate';
import ByMe from './components/ByMe/ByMe';
import PrivacyPolicy from './screens/privacy/privacy';
function App() {
  return (
    <>
      <Navigation/>

      {/* Wrapper for sticky scroll effect - must contain BOTH components */}
      <div className="scroll-container">
        <HeroSection/>
        <IntroSection/>
      </div>

      <ProjectsGallery/>
      <ServicesScreen/>
      <AboutMe/>
      <ShirleyProjects/>
      {/* <ShirliQuate/> */}
      <FAQ_ShirleyGoldstein/>
         <PrivacyPolicy
                      ownerName="שירלי גולדשטיין"
                      email="shirlig2806@gmail.com"
                      phone="+972 54-332-4747"
                      domain="https://sg-studio.co.il/"
                    />
      <ByMe/>
    </>
  );
}

export default App;